import { UserOutlined } from '@ant-design/icons';
import { App, Button, Form, Input, Modal, Table, Tag } from 'antd';
import { SITE } from 'config/config';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { claimReward, historyPredictions } from 'service/base';
import 'styles/global.css';

const HistoryPredictions = ({ isModalVote, setIsModalVote, IP, FP }) => {
  const { notification } = App.useApp();
  const [formHistory] = Form.useForm();
  const [account, setAccount] = useState('');
  const [dataPrediction, setDataPrediction] = useState([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: dataPrediction?.totalRecords || 0,
    size: 'default',
    onChange: (page, pageSize) => {
      console.log('Page change:', page, pageSize);
      setPagination({ ...pagination, current: page });
    }
  });

  // useEffect(() => {
  //   const savedAccount = localStorage.getItem('saved_account');
  //   if (savedAccount) {
  //     formHistory.setFieldsValue({ account: savedAccount });
  //     setAccount(savedAccount);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [formHistory]);

  const handleCancelVote = () => {
    setIsModalVote(false);
  };
  const onFinishHistoryForm = async (data) => {
    try {
      const effectiveAccount = (data.account ?? account).toString().trim();
      if (!effectiveAccount) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập tên đang nhập!'
        });
        return;
      }
      data.account = effectiveAccount;
      setIsLoadingSubmit(true);
      data.site = SITE;
      data.ip = IP;
      data.fp = FP;
      const res = await historyPredictions(data);
      setDataPrediction(res?.data || []);
      if (!res?.data?.responseData?.[0]) {
        notification.warning({
          message: 'Không có lịch sử',
          description: 'Không tìm thấy lịch sử bình chọn, Quý khách vui lòng kiểm tra lại!'
        });
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      setIsLoadingSubmit(false);
    }
  };

  const onFinishHistoryFailed = () => {
    notification.warning({
      message: 'Cảnh báo',
      description: 'Vui lòng kiểm tra lại tài khoản !'
    });
  };

  const handleAccountChange = (event) => {
    const newAccount = event.target.value.trim();
    setAccount(newAccount.trim());
  };

  const handleClaimReward = async (item) => {
    if (item.status_register !== 'apply') {
      return;
    }
    try {
      const accountValue = (item.account || account).trim().toLowerCase();
      const response = await claimReward({
        account: accountValue,
        site: SITE,
        matchId: item.matchId
      });
      if (response?.code === 0) {
        notification.success({ message: 'Thành công', description: 'Nhận thưởng thành công!' });
        await onFinishHistoryForm({ account: accountValue });
      }
    } catch (error) {
      notification.error({
        message: 'Nhận thưởng thất bại!',
        description: error.message
      });
    }
  };

  const columns = [
    {
      title: 'Trận đấu',
      width: '16%',
      render: (_, record) => {
        return record.homeName + ' - ' + record.awayName;
      }
    },
    {
      title: 'Ngày dự đoán',
      dataIndex: 'createdAt',
      width: '12%',
      render: (_, record) => dayjs(record.createdAt).format('DD/MM/YYYY HH:mm')
    },
   
    {
      title: 'Bình chọn',
      width: '8%',
      render: (_, record) => {
        return (
          <Tag className="text-center" color="#000000" key={record._id}>
            {record.homeScore}-{record.awayScore}
          </Tag>
        );
      }
    },
    {
      title: 'Dự đoán giống bạn',
      width: '8%',
      render: (_, record) => {
        return (
          <Tag className="text-center" color="#000000" key={record._id}>
            {record.sameScore}
          </Tag>
        );
      }
    },
    {
      title: 'Cấp VIP',
      width: '8%',
      render: (_, record) => {
        return (
          <Tag className="text-center" color="#000000" key={record._id}>
            {record.vipLevel ?? '-'}
          </Tag>
        );
      }
    },
    {
      title: 'Kết quả',
      width: '8%',
      render: (text, record) => {
        if (record.match_result) {
          return (
            <Tag className="text-center" color="#00890a" key={record._id}>
              {record.match_result}
            </Tag>
          );
        } else {
          return null;
        }
      }
    },
    {
      title: 'Điểm thưởng',
      width: '8%',
      render: (_, record) => (record.point > 0 ? record.point : '-')
    },
    {
      title: 'Nhận thưởng',
      width: '16%',
      render: (_, item) => (
        <div className="flex justify-start">
          <button
            type="button"
            onClick={() => handleClaimReward(item)}
            disabled={item.status_register !== 'apply'}
            className={`px-1 md:px-3 py-2 text-xs md:text-sm rounded-md md:rounded-lg text-white border-none font-semibold ${item.status_register === 'apply' ? 'bg-[#F49A25] cursor-pointer' : 'bg-[#929292] cursor-not-allowed'}`}
          >
            {item.status_register === 'accept' ? 'Đã nhận thưởng' : 'Nhận thưởng'}
          </button>
        </div>
      )
    }
  ];

  return (
    <Modal
      className="modal-jun88k36 modal-history"
      title="DANH SÁCH LỊCH SỬ DỰ ĐOÁN"
      open={isModalVote}
      footer={null}
      onCancel={handleCancelVote}
    >
      <div className="content-km content-history">
        <Form
          name="formHistoryMatch"
          onFinish={onFinishHistoryForm}
          onFinishFailed={onFinishHistoryFailed}
          className="relative"
          autoComplete="off"
          form={formHistory}
          // initialValues={{ account: account }}
        >
          <div className="flex md:justify-center justify-between gap-2 md:py-4 py-1 w-full relative">
            <Form.Item
              name="account"
              className="mb-0 min-w-[30%] md:min-h-[38px] w-full max-w-[600px]"
            >
              <Input
                className="min-h-[38px] w-full"
                placeholder="Nhập tên đăng nhập ..."
                maxLength={30}
                value={account}
                onChange={handleAccountChange}
                prefix={<UserOutlined />}
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng điền tên đăng nhập!'
                  }
                ]}
              />
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoadingSubmit}
                className="bg-score bg-check-account text-white font-medium min-h-[32px] absolute right-3 top-[50%] translate-y-[-50%] z-30"
              >
                Xác Nhận
              </Button>
            </Form.Item>
          </div>
        </Form>
        <div className="list-history">
          <Table
            size="small"
            rowKey={(r) => r._id ?? `${r.matchId}-${r.account}`}
            columns={columns}
            dataSource={dataPrediction?.responseData || []}
            loading={isLoadingSubmit}
            pagination={pagination}
            scroll={{ x: 'max-content' }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default HistoryPredictions;
